export const HOME_ALL_BILLS = 'all_bills';
export const HOME_BANK_ACCOUNT = 'bank_account';
export const HOME_TRANSFERS = 'transfers';
export const HOME_REQUIREMENTS = 'requirements';

export const HOME_OPTIONS = [
  { value: HOME_ALL_BILLS, label: 'All Bills' },
  { value: HOME_BANK_ACCOUNT, label: 'A bank account bills page' },
  { value: HOME_TRANSFERS, label: 'Transfers' },
  { value: HOME_REQUIREMENTS, label: 'Requirements' },
];

export const DEFAULT_NAVIGATION_PREFERENCES = {
  desktop_home: HOME_ALL_BILLS,
  desktop_home_bank_account_id: null,
  mobile_home: HOME_ALL_BILLS,
  mobile_home_bank_account_id: null,
};

/** Match phone layout breakpoints (portrait or landscape phone). */
export const isPhoneViewport = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return width <= 480 || (height <= 480 && width <= 896);
};

export const resolveHomePath = (tenant, preferences, platform = 'desktop') => {
  const prefs = preferences || DEFAULT_NAVIGATION_PREFERENCES;
  const homeType = platform === 'mobile' ? prefs.mobile_home : prefs.desktop_home;
  const bankAccountId =
    platform === 'mobile'
      ? prefs.mobile_home_bank_account_id
      : prefs.desktop_home_bank_account_id;
  const prefix = tenant ? `/$/${tenant}` : '';

  switch (homeType) {
    case HOME_TRANSFERS:
      return `${prefix}/transfers`;
    case HOME_REQUIREMENTS:
      return `${prefix}/requirements`;
    case HOME_BANK_ACCOUNT:
      return bankAccountId ? `${prefix}/track/${bankAccountId}` : `${prefix}/track`;
    case HOME_ALL_BILLS:
    default:
      return `${prefix}/track`;
  }
};
